import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=69bfe2d2&scoped=true&"
import script from "./accordion.vue?vue&type=script&lang=js&"
export * from "./accordion.vue?vue&type=script&lang=js&"
import style0 from "./accordion.vue?vue&type=style&index=0&id=69bfe2d2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bfe2d2",
  null
  
)

export default component.exports